<!-- Component to show:
    Sensor Message details

  Props:
      1. message: Sensor message to be shown
      2. sensor: Sensor object related to this messages.
      3. fields: Visible fields for sensor message details
      4. showBackButton: Indicates if back button must be shown

-->
<template>
  <div>
    <p class="title-detail">Sensor Message Details ({{ sensor.name }})</p>
    <div class="text-right mr-3 mb-3">
      <b-link v-if="showBackButton" @click="$emit('fnShowMessageList', true)"> Back </b-link>
    </div>
    <b-table id="message-detail-table"
             :items="[message]"
             :fields="fields.message_detail"
             stacked
             show-empty>

      <template v-slot:cell(sampleDateTime)="item">
        {{item.item.sampleDateTime | formatDateTime}}
      </template>

      <template v-slot:cell(receivedDateTime)="item">
        {{item.item.receivedDateTime | formatDateTime}}
      </template>
    </b-table>

  </div>


</template>

<script>

  export default {
    name: 'k-sensor-msg-details',
    props: {
      message: { type: Object, default: {}, required: true },
      sensor: { type: Object, required: true },
      fields: { type: Array, default: [], required: true },
      showBackButton: { type: Boolean, default: false, required: false }
    },
    data() {
      return {
      }
    },

    mounted() { },

    methods: {
      display_message_detail() { },
    }

  }

</script>

<style scoped>
  .title-detail {
    margin-bottom: -24px;
    left: 0px;
    right: 0px;
    font-weight: bold;
  }
</style>
